import axios from 'axios'
import { defineStore } from 'pinia'
import { notify } from '@kyvg/vue3-notification'

import WebChat from '@/views/dash/channels/Pages/Webchat.vue'
import Telegram from '@/views/dash/channels/Pages/Telegram.vue'
import TelegramAccount from '@/views/dash/channels/Pages/TelegramAccount.vue'
import Instagram from '@/views/dash/channels/Pages/Instagram.vue'
import InstagramV2 from '@/views/dash/channels/Pages/InstagramV2.vue'
import Messenger from '@/views/dash/channels/Pages/Messenger.vue'
import WhatsappWeb from '@/views/dash/channels/Pages/WhatsappWeb.vue'
import Whatsapp360 from '@/views/dash/channels/Pages/Whatsapp360.vue'
import WhatsappMeta from '@/views/dash/channels/Pages/WhatsappMeta.vue'
import WhatsappOtima from '@/views/dash/channels/Pages/WhatsappOtima.vue'
import InternalChat from '@/views/dash/channels/Pages/InternalChat.vue'
import WebchatV2 from '@/views/dash/channels/Pages/WebchatV2.vue'
import WhatsappOtimaLogo from '@/assets/images/icons/whatsapp_otima.svg'

import Dialog360 from '@/assets/images/icons/dialog360.svg'
import WhatsAppIcon from '@/assets/images/icons/whatsapp_meta.svg'
import TelegramLogo from '@/assets/images/icons/telegram.svg'
import WhatsAppLogo from '@/assets/images/icons/whatsapp.svg'
import InstagramLogo from '@/assets/images/icons/instagram.png'
import MessengerLogo from '@/assets/images/icons/messenger.svg'
import WhatsCloud from '@/assets/images/icons/whatsapp-cloud.svg'
import WhatsAppWebLogo from '@/assets/images/icons/whatsapp-web.svg'
import WebChatLogo from '@/assets/images/icons/webchat-gradient.png'
import InternalChatLogo from '@/assets/images/icons/internal-chat.png'
import { findById } from '@/utils/index'
import { useUsersStore } from './users'
import { getUrlBaseV2, getUrlApiV1 } from '@/utils/index'
export const useChannelsStore = defineStore('channels', {
    state: () => ({
        channels: [],
        channel: {},
        formStep: 1,
        loading: false,
        loadingPage: false,
        loadingStart: false,
    }),

    getters: {
        telephonyOmnichannels: state => state.channels.filter(channel => channel.telephony_omnichannel === 'true' || channel.telephony_omnichannel === true),
        getById: (state) => (id) => findById(state.channels, parseInt(id)),
        /**
         * @param state
         * @returns {array}
         */
        prepareChannels: state => {
            return state.channels.map(channel => ({
                id: channel.id,
                server_token: channel.api_id,
                api_id: channel.server_id,
                api_token: channel.api_token,
                server_id: channel.go_id,
                name: channel.name,
                status: channel.status,
                external_id: channel.more.external_id,
                icon: state.defineIcon(channel.server_type),
                server_type: channel.server_type,
                user: channel.user,
                type: channel.type,
                business_id: channel.business_id,
                start_service: channel.start_service,
                visible_in_start_attendance: channel.visible_in_start_attendance,
                more: channel.more
            }))
        },

        defineForm: (state) => {
            const st = state.channel?.server_type
            if (!st) {
                return null
            }

            const channelForm = {
                internalchat: InternalChat,
                webchat: WebChat,
                webchat_v2: WebchatV2,
                whatsapp: WhatsappWeb,
                go: WhatsappWeb,
                goMD: WhatsappWeb,
                gomd: WhatsappWeb,
                dialog360_cloud: Whatsapp360,
                dialog360: Whatsapp360,
                whatsapp_meta: WhatsappMeta,
                otima: WhatsappOtima,
                messenger: Messenger,
                instagram: Instagram,
                instagram_v2: InstagramV2,
                telegram: Telegram,
                telegram_account: TelegramAccount,
            }
            return channelForm[st] ?? channelForm[String(st).toLowerCase()] ?? null
        },

        getByType: (state) => (type) => state.channels.filter(el => el.type === type),
    },

    actions: {
        /**
         * @param {int|null} channelId
         * @param {boolean} force
         */
        getChannels(channelId = null, force = false) {
            channelId = parseInt(channelId)

            if (channelId && this.channels.length) {
                const channel = this.channels.filter(item => item.id === channelId)
                if (channel.length) this.channel = channel[0]
                return
            }

            if (!force && this.channels.length) return

            this.loading = true
            axios.get(`${getUrlApiV1()}/channel`)
                .then(response => {
                    this.channels = response.data.data

                    if (!channelId) return

                    const channel = this.channels.filter(item => item.id === channelId)

                    if (channel.length) this.channel = channel[0]
                })
                .catch(error => {
                    console.error(error)

                    notify({
                        type: 'error',
                        title: 'Oh não',
                        text: 'Houve um erro ao buscar os dados dos canais. Por favor, tente novamente.',
                    })
                })
                .finally(() => {
                    if (!force) this.loading = false
                })
        },

        defineIcon(serverType) {
            if (!serverType) return

            const channelForm = {
                internalchat: InternalChatLogo,
                webchat: WebChatLogo,
                webchat_v2: WebChatLogo,
                whatsapp: WhatsAppLogo,
                go: WhatsAppWebLogo,
                gomd: WhatsAppWebLogo,
                dialog360: Dialog360,
                dialog360_cloud: Dialog360,
                whatscloud: WhatsCloud,
                whatsapp_meta: WhatsAppIcon,
                telegram: TelegramLogo,
                telegram_account: TelegramLogo,
                telegram_select: TelegramLogo,
                instagram: InstagramLogo,
                instagram_v2: InstagramLogo,
                instagram_select: InstagramLogo,
                messenger: MessengerLogo,
                otima: WhatsappOtimaLogo,
            }

            return channelForm[serverType.toLowerCase()]
        },

        /**
         * @param {int|null} channelId
         */
        removeChannel(channelId) {
            channelId = parseInt(channelId)
            this.channels = this.channels.filter(item => item.id !== channelId)
        },

        registerMeta(payload) {
            this.loading = true
            setTimeout(() => this.loading = false, 5000)
        },
    },
})
